import { RemittanceIcon, FinancingIcon, ReKYCIcon, ReferralIcon, InsuranceIcon } from "../icons"

import StatusCards from "./StatusCard";

export const OpportunityJourneySquare = ({oppData}) => {
    console.table(oppData);
    
    const getCardsForFunnel = (funnel, status, lead_status) => {
        const commonCards = [
            {title: "Qualification", status: "in-progress", statusLabel: "In Progress"},
            {title: "Informaton Gathered", status: "not-started", statusLabel: "Not Started"},
            {title: "Conversion", status: "not-started", statusLabel: "Not Started"},
        ];
        
        switch(funnel) {
            case 'Re-KYC':
                if ((status === 7) && (lead_status === 5)){
                    return [
                        { title: "Qualification", status: "completed", statusLabel: "Completed"}
                    ];
                } else {
                    return [
                        { title: "Qualification", status: "in-progress", statusLabel: "In Progress"}
                    ];
                }
            
            case 'Remittance':
                // Add specific card configuration for Remittance
                return commonCards;
                
            case 'Financing':
                // Add specific card configuration for Financing
                if (((status === 0) || (status === 1)) && ((lead_status === 0) || (lead_status === 1))){
                    return [
                        {title: "Qualification", status: "in-progress", statusLabel: "In Progress"},
                        {title: "Information Gathered", status: "not-started", statusLabel: "Not Started"},
                        {title: "Conversion", status: "not-started", statusLabel: "Not Started"},
                    ];
                } else if (((status === 2) ) && (lead_status === 2)){
                    return [
                        { title: "Qualification", status: "completed", statusLabel: "Completed"},
                        { title: "Information Gathered", status: "in-progress", statusLabel: "In Progress"},
                        { title: "Conversion", status: "not-started", statusLabel: "Not Started"}
                    ];
                } else if ((status === 3) && (lead_status === 3)){
                    return [
                        { title: "Qualification", status: "completed", statusLabel: "Completed"},
                        { title: "Information Gathered", status: "completed", statusLabel: "Completed"},
                        { title: "Conversion", status: "in-progress", statusLabel: "In Progress"}
                    ];
                } else {
                    return [
                        { title: "Qualification", status: "completed", statusLabel: "Completed"},
                        { title: "Information Gathered", status: "completed", statusLabel: "Completed"},
                        { title: "Conversion", status: "completed", statusLabel: "Completed"}
                    ];
                }
                
            case 'Referral':
                // Add specific card configuration for Referral
                if (status === 0) {
                    return [
                        { title: "Qualification", status: "in-progress", statusLabel: "In Progress"},
                        {title: "Information Gathering", status: "not-started", statusLabel: "Not Started"},
                    ];
                } else if (status === 1) {
                    return [
                        { title: "Qualification", status: "completed", statusLabel: "Completed"},
                        {title: "Information Gathering", status: "in-progress", statusLabel: "In Progress"},
                    ];
                } else if (status === 2) {
                    return [
                        { title: "Qualification", status: "completed", statusLabel: "Completed"},
                        {title: "Information Gathering", status: "completed", statusLabel: "Completed"},
                    ];
                }
                return commonCards;
                
            case 'Insurance':
                // Add specific card configuration for Insurance
                if ((status === 7) && (lead_status === 5)){
                    return [
                        { title: "Qualification", status: "completed", statusLabel: "Completed"},
                        { title: "Informaton Gathered", status: "completed", statusLabel: "Completed"},
                        { title: "Conversion", status: "in-progress", statusLabel: "In Progress"}
                    ];
                } else if ((status === 7) && (lead_status === 4)){
                    return [
                        { title: "Qualification", status: "completed", statusLabel: "Completed"},
                        { title: "Informaton Gathered", status: "in-progress", statusLabel: "In Progress"},
                        { title: "Conversion", status: "not-started", statusLabel: "Not Started"}
                    ];
                } else {
                    return [
                        { title: "Qualification", status: "in-progress", statusLabel: "In Progress"},
                        { title: "Informaton Gathered", status: "not-started", statusLabel: "Not Started"},
                        { title: "Conversion", status: "not-started", statusLabel: "Not Started"}
                    ];
                }
                
            default:
                return commonCards;
        }
    };
    
    const cards = getCardsForFunnel(oppData.funnel, oppData.status, oppData.lead_status);
    
    const getOpportunityStatus = (status) => {
        const styles = {
            'Raw Lead': "bg-[#FFEEDC] border-[#FFEEDC] text-[#ED9812]",
            'Fresh Lead': "bg-[#FEFAD8] border-[#FEFAD8] text-[#B1A106]",
            'Profile Completed': "bg-[#BEC2FF] border-[#BEC2FF] text-[#262BC6]",
            'Activated': "bg-[#E7FFD6] border-[#E7FFD6] text-[#116D26]",
            'Rejected': "bg-[#FFEDE9] border-[#FFEDE9] text-[#DD3730]",
            'Informaton Gathered': "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
            'Onboarded': "bg-[#E7FFD6] border-[#E7FFD6] text-[#116D26]",
            'Collecting Documents': "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
            'Compliance Reviewing': "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
            'KYC Approved': "bg-[#E7FFD6] border-[#E7FFD6] text-[#116D26]",
            'To Be Re-KYC': "bg-[#FFEEDC] border-[#FFEEDC] text-[#ED9812]",
            'KYC Rejected': "bg-[#FFEDE9] border-[#FFEDE9] text-[#DD3730]",
            'Preparing Quotations': "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
            'Pending Selected': "bg-[#FFEEDC] border-[#FFEEDC] text-[#ED9812]",
            'Pending Payment': "bg-[#FEFAD8] border-[#FEFAD8] text-[#B1A106]",
            'Expired': "bg-[#EEEEEE] border-[#EEEEEE] text-[#94A3B8]"
        };
        return styles[status] || "bg-gray-100 text-gray-600";
    };

    return(
        <div className='w-full'>
            <div className="bg-white rounded-3xl shadow-sm p-6 ml-8 mr-8 mt-5">
                <p className="font-light ml-1">Opportunity ID: #{oppData.sub_id}</p>
                <p className="font-extrabold text-4xl mt-2 mb-5 ml-1"><b>{oppData.name}</b></p>
                <div className="flex items-center mb-3">
                    <span className="py-2 px-4">
                        {
                            oppData.funnel === 'Remittance' && (
                                <img src={RemittanceIcon} alt="Remittance" className="inline-block w-6 h-6 mr-2"/>
                            )
                        }
                        {
                            oppData.funnel === 'Financing' && (
                                <img src={FinancingIcon} alt="Financing" className="inline-block w-6 h-6 mr-2"/>
                            )
                        }
                        {
                            oppData.funnel === 'Re-KYC' && (
                                <img src={ReKYCIcon} alt="ReKYC" className="inline-block w-6 h-6 mr-2"/>
                            )
                        }
                        {
                            oppData.funnel === 'Referral' && (
                                <img src={ReferralIcon} alt="Referral" className="inline-block w-6 h-6 mr-2"/>
                            )
                        }
                        {
                            oppData.funnel === 'Insurance' && (
                                <img src={InsuranceIcon} alt="Insurance" className="inline-block w-6 h-6 mr-2"/>
                            )
                        }
                    </span>
                    <span className={`w-auto h-[34px] py-2 px-4  gap-2 top-5 left-[22px] rounded-full border font-bold ${getOpportunityStatus(oppData.status_name)} items-center justify-center flex`}>
                        {oppData.status_name}
                    </span>
                </div>
                <div className="bg-gray-100 p-4 rounded-3xl border-opacity-20 border-2">
                    <div>
                        <div className="w-full flex jsutify-between items-center mt-3 bg-gray-100 rounded-lg">
                            <div className="flex mb-4 items-center">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                    className="h-6 w-6 mr-4"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M9.348 14.652a3.75 3.75 0 0 1 0-5.304m5.304 0a3.75 3.75 0 0 1 0 5.304m-7.425 2.121a6.75 6.75 0 0 1 0-9.546m9.546 0a6.75 6.75 0 0 1 0 9.546M5.106 18.894c-3.808-3.807-3.808-9.98 0-13.788m13.788 0c3.808 3.807 3.808 9.98 0 13.788M12 12h.008v.008H12V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
                                    />
                                </svg>
                                <p className="font-bold text-2xl">Pipeline Progress</p>
                            </div>
                        </div>
                        <div className="bg-gray-100">
                            <StatusCards cards={cards} funnel={oppData.funnel}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}